var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18a11.827 11.827 0 01-8.344-3.772 20.86 20.86 0 01-3.506-4.6L.075 9.5c-.1-.292-.1-.608 0-.9C.25 8.249 4.452 0 12 0c7.53 0 11.75 8.249 11.925 8.6.1.257.1.543 0 .8C23.748 9.751 19.527 18 12 18zm0-16a9.8 9.8 0 00-6.653 2.9A17.665 17.665 0 002.078 9c2.87 4.579 6.3 7 9.921 7 3.621 0 7.054-2.421 9.921-7-2.867-4.579-6.298-7-9.92-7zm0 11a4 4 0 114.008-4A4.008 4.008 0 0112 13zm0-6a2 2 0 100 4 2 2 0 000-4z"
  })));
}
export default SvgEyeOpen;